export const Config = {
  /** Google services key. */
  googleKey: process.env.REACT_APP_GOOGLE_API_KEY,
  /** Encryption key for local storage values. */
  cryptoKey: process.env.REACT_APP_CRYPTO_KEY || 'secret',
};
